import SettingsModule from 'automation-ui-canvas/containers/settings/v2/SettingsModule';
import FormattedMessage from 'I18n/components/FormattedMessage';
import HolidayManagement from 'automation-ui-canvas/components/settings/HolidayManagement';
import TimeWindowMetadata from 'automation-ui-canvas/flow/records/properties/Timing/TimeWindowMetadata';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import DocButton from 'automation-ui-usage-tracking/components/DocButton';
import { SupportLinkKeys } from 'automation-ui-usage-tracking/SupportLinks';
import { jsx as _jsx } from "react/jsx-runtime";
const HolidayManagementSetting = ({
  readOnly,
  onChange,
  settings: {
    timeWindow
  }
}) => {
  return /*#__PURE__*/_jsx(SettingsModule, {
    header: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "settingsV2.holidayManagementSetting.title"
    }),
    description: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "settingsV2.holidayManagementSetting.description_jsx",
      elements: {
        Link: () => /*#__PURE__*/_jsx("div", {
          children: /*#__PURE__*/_jsx(DocButton, {
            supportKey: SupportLinkKeys.LEARN_MORE_ABOUT_EXECUTION_TIMING
          })
        })
      }
    }),
    body: /*#__PURE__*/_jsx(HolidayManagement, {
      use: "compact",
      stagedTimeWindowMetadata: timeWindow || new TimeWindowMetadata(),
      onUpdateStagedTimeWindowMetadata: newTimeWindowMetadata => {
        onChange({
          timeWindow: newTimeWindowMetadata
        });
      },
      readOnly: readOnly
    })
  });
};
export default HolidayManagementSetting;